import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


function initStepsAnimation() {
   if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);

      const stepCards = document.querySelectorAll(".steps-section .step-card");

      if (stepCards.length > 0) {
         gsap.from(stepCards, {
            scrollTrigger: {
               trigger: ".steps-section",
               start: "top 70%",
               toggleActions: "play none none none"
            },
            x: -100,            // Slides in smoothly from the left side
            opacity: 0,         // Fades in gradually

            transformPerspective: 1000,
            duration: 1.8,      // Slow and elegant transition speed
            stagger: 0.5,       // Generous delay so each step appears sequentially one after another
            ease: "power3.out"
         });
      }
   }
}
function initVerlegeanleitungAnimations() {
   if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return;
   }

   gsap.registerPlugin(ScrollTrigger);

   gsap.utils.toArray('.step-card').forEach((card) => {
      gsap.fromTo(card,
         {
            opacity: 0,
            y: 50
         },
         {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            scrollTrigger: {
               trigger: card,
               start: 'top 85%',
               once: true
            }
         }
      );
   });
}


jQuery(document).ready(function ($) {
   initStepsAnimation();
   initVerlegeanleitungAnimations();
});